import React, { useMemo, useState } from 'react';
import classNames from 'classnames';
import profileUrl from '../../../../utils/profileUrl';
import Layout1 from './Layout1';
import Layout2 from './Layout2';
import Layout3 from './Layout3';
import ProfileLink from './ProfileLink';
import Share from './Share';
import useAggregateContacts from '../../../../hooks/useAggregateContacts';
import useLocalitySuburb from '../../../../hooks/useLocalitySuburb';
import getPackage from '../../../../utils/getPackage';
import getPackageLayout from '../../../../utils/getPackageLayout';
import './styles.css';

const Card = ({
  data,
  market,
  index,
  searchKeyword,
  categoryId,
  regionCitySearch,
}) => {
  const [showQuickInfo, setShowQuickInfo] = useState();

  const {
    name,
    suburb,
    state,
    locations,
    hash,
    paid,
    package: packageType,
    category_score: categoryScore,
    listing_id: listingId,
    main_contacts: mainContacts,
    additional_contacts: additionalContacts,
    freeGoldPackage,
  } = data || {};

  const locality = useLocalitySuburb(locations, suburb, state);
  const { localitySuburb, localityState } = locality || {};

  const packageName = useMemo(
    () =>
      getPackage({
        categoryScore,
        packageType,
        paid,
        category: searchKeyword || '',
        freeGoldPackage,
      }),
    [categoryScore, packageType, paid, searchKeyword]
  );
  const cardLayout = getPackageLayout(packageName);

  const aggregateContacts = useAggregateContacts([
    ...mainContacts,
    ...additionalContacts,
  ]);

  const { layout } = cardLayout || {};

  const { callNumbers } = aggregateContacts || {};
  const url = profileUrl({
    name,
    suburb: localitySuburb,
    state: localityState,
    hash,
  });

  return (
    <div
      data-hash={hash}
      data-listingid={listingId}
      data-index={index}
      className={classNames('Listview__Card__root', {
        [`Listview__Card__root--${packageType}`]: packageType,
        [`Listview__Card__root--client`]: paid,
        [`Listview__Card__root--nonClient`]: !paid,
        [`Listview__Card__root--${layout}`]: layout,
      })}
    >
      <Share
        url={url}
        name={name}
        phone={callNumbers && !!callNumbers.length && callNumbers[0].info}
        suburb={suburb}
        state={state}
      />

      <ProfileLink url={url} className="Listview__Card__link">
        {name}
      </ProfileLink>
      {layout === 'layout1' && (
        <Layout1
          data={data}
          aggregateContacts={aggregateContacts}
          url={url}
          cardLayout={cardLayout}
          market={market}
          categoryId={categoryId}
          showQuickInfo={showQuickInfo}
          setShowQuickInfo={setShowQuickInfo}
          regionCitySearch={regionCitySearch}
        />
      )}
      {layout === 'layout2' && (
        <Layout2
          data={data}
          aggregateContacts={aggregateContacts}
          url={url}
          cardLayout={cardLayout}
          market={market}
          categoryId={categoryId}
          showQuickInfo={showQuickInfo}
          setShowQuickInfo={setShowQuickInfo}
          regionCitySearch={regionCitySearch}
        />
      )}
      {layout === 'layout3' && (
        <Layout3
          data={data}
          url={url}
          showQuickInfo={showQuickInfo}
          setShowQuickInfo={setShowQuickInfo}
          aggregateContacts={aggregateContacts}
          regionCitySearch={regionCitySearch}
        />
      )}
    </div>
  );
};
export default Card;
